<ng-container *ngIf="!onlyUrl">
  <div class="image-wrapper" *ngIf="!isLoading && preview" [ngClass]="{'borderless': noBorder, 'slim': slim, 'custom-container': customContainer}">
    <span class="badge" *ngIf="badge">{{ ratio.replace('x', ':') }}</span>
    <img *ngIf="!backgroundBased" [src]="preview" [ngClass]="{'logo': ratio === S3UploaderRatios.Logo, 'limited': !originalSize, 'inline': inline}" />
    <div *ngIf="backgroundBased" class="background-based image-blur" [ngStyle]="{'background-image': 'url(\'' + preview + '\')'}"></div>
  </div>
  <app-loader class="top-spacer bottom-spacer" [loading]="isLoading" [size]="16"></app-loader>
</ng-container>
